<template>
  <div class="content-approval-header-inner">
    <nav class="tabs-list">
      <a
        class="tab-item"
        :class="{ active: status === activeStatus }"
        @click="updateActiveStatus(status)"
        v-for="status in entryApprovalStatuses"
        :key="status"
      >
        <p class="text">{{ $t(status) }}</p>
        <p class="number">{{ getEntriesByStatus(status, searchWord).length }}</p>
      </a>
    </nav>
    <div class="search-content">
      <input
        class="search-content-input"
        type="text"
        v-model="searchText"
        :placeholder="$t('SEARCH_PLACEHOLDER')"
        @keyup.enter="searchResults"
      />
       <button class="search-button" @click="searchResults"></button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import { entryApprovalStatuses } from '@/constants'

export default {
  name: 'content-approval-header',

  data () {
    return {
      activeStatus: entryApprovalStatuses.PENDING,
      entryApprovalStatuses,
      /**  Because we want the search to be performed only after pressing enter, we use searchText to save the search text and not directly the searchWord from store */
      searchText: null
    }
  },

  computed: {
    ...mapGetters(['getEntriesByStatus']),
    ...mapState({
      searchWord: state => state.collections.searchWord
    })
  },

  mounted () {
    this.searchText = this.searchWord
  },

  watch: {
    searchText: function () {
      // If the search text is deleted, the search results are reset automatically
      if (!this.searchText?.length && this.searchWord) {
        this.searchResults()
      }
    }
  },

  methods: {
    // The list of entries to be displayed is determined by the selected status (pending, published, rejected)
    updateActiveStatus (status) {
      this.activeStatus = status
      this.$emit('updateSelectedEntryStatus', status)
    },
    searchResults () {
      // If the user deletes searchText after a search has already been performed
      if (this.searchText === '' && this.$route.query.searchText) {
        this.searchText = null
        this.$router.push({ name: 'contentApproval', query: { filters: this.$route.query.filters } })
      } else if (this.searchText !== this.searchWord) {
        // Adding parameters only for edited search text or non-empty search
        this.$router.push({ name: 'contentApproval', query: { searchText: this.searchText, filters: this.$route.query.filters } })
      }
      this.$store.dispatch('setSearchWord', this.searchText)
    }
  }
}
</script>

<style lang="scss" scoped>
.content-approval .search-content{
  &:before{background-image: none;}
}
.search-button{
  width: 20px; cursor: pointer;
  background-image: url('../assets/images/search_grey_icon.svg'); background-repeat: no-repeat;
  position: absolute; top: 4px; height: 20px; inset-inline-end: 60px; background-size: contain;
  &:after{background-image: none; background-color: transparent;}
}
</style>
